export const logo =
  'https://res.cloudinary.com/doti9oyov/image/upload/f_webp/icons/qz45ngnunzc2pu0w4m9c.jpg';
export const shortLogo =
  'https://res.cloudinary.com/doti9oyov/image/upload/v1711902983/icon_kagzdo.webp';
